import { inject, Injectable } from "@angular/core";
import { getBackendErrorMessage } from "../../../Common/Utility/UtilityError";
import { DashboardApi } from "../Api/DashboardApi";
import { DashboardPeriod } from "../Dto/DashboardOverviewResponse";
import { DashboardState } from "./DashboardState";

@Injectable({ providedIn: "root" })
export class DashboardEffects {
  private readonly dashboardApi = inject(DashboardApi);
  private readonly dashboardState = inject(DashboardState);

  async loadOverview(period: DashboardPeriod = this.dashboardState.selectedPeriod()): Promise<void> {
    this.dashboardState.setSelectedPeriod(period);
    this.dashboardState.setLoading(true);
    this.dashboardState.setError(null);

    try {
      const [overview, fulfillmentFunnel] = await Promise.all([
        this.dashboardApi.getOverview(period),
        this.dashboardApi.getFulfillmentFunnel(period),
      ]);
      this.dashboardState.setOverview(overview);
      this.dashboardState.setFulfillmentFunnel(fulfillmentFunnel);
    } catch (exception: unknown) {
      this.dashboardState.setError(getBackendErrorMessage(exception, "Unable to load dashboard overview."));
    } finally {
      this.dashboardState.setLoading(false);
    }
  }
}
